import type { CardData } from './types';

export const SECTOR_COLORS: Record<string, { from: string; to: string }> = {
  secretaria:     { from: '#10B981', to: '#059669' },
  financeiro:     { from: '#F43F5E', to: '#E11D48' },
  pedagogico:     { from: '#A855F7', to: '#EC4899' },
  administrativo: { from: '#F59E0B', to: '#EAB308' },
  suporte:        { from: '#06B6D4', to: '#3B82F6' },
  direcao:        { from: '#64748B', to: '#475569' },
};

export const SECTOR_NAMES: Record<string, string> = {
  secretaria:     'Secretaria',
  financeiro:     'Financeiro',
  pedagogico:     'Pedagógico',
  administrativo: 'Administrativo',
  suporte:        'Suporte',
  direcao:        'Direção',
};

export const PRIORITY_LABEL: Record<CardData['priority'], string> = {
  urgent: 'Urgente',
  high: 'Alta',
  medium: 'Média',
  low: 'Baixa',
};

// Espelha BoardLabel.ColorChoices (eleveia-api, apps/boards/models/board/board_label.py)
export interface LabelColorOption {
  value: string;
  label: string;
  dot: string;
  chip: string;
}

export const LABEL_COLOR_OPTIONS: LabelColorOption[] = [
  { value: 'red',    label: 'Vermelho', dot: 'bg-red-500',     chip: 'bg-red-100 text-red-700' },
  { value: 'orange', label: 'Laranja',  dot: 'bg-orange-500',  chip: 'bg-orange-100 text-orange-700' },
  { value: 'yellow', label: 'Amarelo',  dot: 'bg-yellow-400',  chip: 'bg-yellow-100 text-yellow-800' },
  { value: 'green',  label: 'Verde',    dot: 'bg-emerald-500', chip: 'bg-emerald-100 text-emerald-700' },
  { value: 'blue',   label: 'Azul',     dot: 'bg-blue-500',    chip: 'bg-blue-100 text-blue-700' },
  { value: 'purple', label: 'Roxo',     dot: 'bg-purple-500',  chip: 'bg-purple-100 text-purple-700' },
  { value: 'pink',   label: 'Rosa',     dot: 'bg-pink-500',    chip: 'bg-pink-100 text-pink-700' },
  { value: 'gray',   label: 'Cinza',    dot: 'bg-slate-400',   chip: 'bg-slate-100 text-slate-700' },
];

export const DEFAULT_LABEL_COLOR = LABEL_COLOR_OPTIONS[7];

export function getLabelColor(color: string): LabelColorOption {
  return LABEL_COLOR_OPTIONS.find((c) => c.value === color) ?? DEFAULT_LABEL_COLOR;
}

// ELE-78: templates de checklist por setor (hardcoded no frontend)
export interface ChecklistTemplate {
  label: string;
  items: string[];
}

export const CHECKLIST_TEMPLATES: Record<string, ChecklistTemplate[]> = {
  secretaria: [
    {
      label: 'Matrícula Nova',
      items: [
        'RG ou Certidão de Nascimento',
        'Comprovante de residência',
        'Histórico escolar anterior',
        'Declaração de transferência',
        'Foto 3x4',
        'Ficha de matrícula preenchida',
      ],
    },
    {
      label: 'Declaração de Matrícula',
      items: [
        'Verificar matrícula ativa no SIGA',
        'Gerar documento no sistema',
        'Coletar assinatura do diretor',
        'Carimbar e registrar saída',
        'Entregar ao aluno / responsável',
      ],
    },
    {
      label: 'Declaração de Frequência',
      items: [
        'Verificar frequência no SIGA',
        'Calcular percentual',
        'Gerar documento',
        'Assinar e carimbar',
        'Entregar',
      ],
    },
    {
      label: 'Transferência',
      items: [
        'Solicitar histórico escolar',
        'Emitir declaração de transferência',
        'Recolher material didático',
        'Processar saída no sistema',
        'Arquivar documentação',
      ],
    },
  ],
};
